import React, { FC } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { connect } from 'react-redux';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { useBackgroundColor } from '@v2/pages/machines/hooks/useBackgroundColor';

interface JobDocumentsProps extends NavigationProps {
  jobId: number | null;
}

const JobDocumentsComponent: FC<JobDocumentsProps> = ({ lg, jobId }) => {
  const { machineScreenMainBg } = useBackgroundColor();

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      {jobId != null && (
        <View style={[MACHINES_PAGES_CONTAINER_STYLES, {paddingHorizontal: 0}]}>
          <ImagesDocumentsContent
            documentRetrieveId={jobId}
            documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOperation}
            bigSliderBg={machineScreenMainBg}
            smallSliderBg={machineScreenMainBg}
          />
        </View>
      )}
    </MachinesProvider>
  );
};

const JobDocuments = connect(({ details: { jobId } }) => ({ jobId }), {})(JobDocumentsComponent);

export { JobDocuments };
